
// export const BaseGatewayImage = 'https://localhost:5001';
// export const BaseGateway = 'https://localhost:5001/api/v1';

export const BaseGatewayImage = 'https://api.corehub.cntt108.vn';
export const BaseGateway = 'https://api.corehub.cntt108.vn/api/v1';

export const BaseGatewayAuthApi = 'https://api.authservice.cntt108.vn/api/v1';
export const BaseGatewayAuth = 'https://api.authservice.cntt108.vn';
export const BaseGatewayAuthImage = 'https://api.authservice.cntt108.vn';

// export const BaseGatewayAuthApi = 'https://localhost:5003/api/v1';
// export const BaseGatewayAuth = 'https://localhost:5003';
// export const BaseGatewayAuthImage = 'https://localhost:5003';

// export const BaseGatewayImage = 'http://localhost:5000';
// const BaseGateway = 'http://localhost:5000/api/v1';

// export const BaseGatewayImageAuth = 'http://localhost:5002';
// const BaseGatewayAuth = 'http://localhost:5002';

const BaseGatewayFromMainServer = 'http://108.108.108.52:10808';

export const  BaseGatewayClient  = 'http://interbgc.com.vn'

const BaseGatewayCrawler = 'http://crawlerapi.xecong.info';
// api chung lấy nguộn 
export const AUTH_API = {
    LOGIN_API: `${BaseGatewayAuth}/connect/token`,
    REFRESHTOKEN_API: `${BaseGatewayAuth}/connect/token`,
    CHANGE_PASSWORD_API: `${BaseGatewayAuthApi}/Auth/ChangePassword`,
    FORGOT_PASSWORD: `${BaseGatewayAuth}/Auth/ForgotPassword`,
    RESET_PASSWORD: `${BaseGatewayAuth}/Auth/ResetPassword`
};

export const ACCOUNT_API = {
    GET_PAGING_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetAllPaging`,
    ADD_ACCOUNT: `${BaseGatewayAuthApi}/Account/Create`,
    EDIT_ACCOUNT: `${BaseGatewayAuthApi}/Account/Update`,
    DELETE_ACCOUNT: `${BaseGatewayAuthApi}/Account/DeleteItem`,
    GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetItem`,
    COUNT_ALL_ACCOUNT_API: `${BaseGatewayAuthApi}/Account/CountAllAccount`
};

export const OPENIDDICTAPPLICATION_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/OpeniddictApplication/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/DeleteItem`
};

export const FILE_MANAGER_API = {
    UPLOAD: `${BaseGatewayAuthApi}/FileManager/Upload`,
    GET_PAGING: `${BaseGatewayAuthApi}/FileManager/GetAllByPaging`,
    GET_DIR_PATH: `${BaseGatewayAuthApi}/FileManager/GetDirectoryPath`,
    DELETE: `${BaseGatewayAuthApi}/FileManager`
};

export const EMAILCONFIG_API = {
    GET_PAGING_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetAllByPaging`,
    GET_ITEM_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetItem`,
    ADD_EMAILCONFIG: `${BaseGateway}/EmailConfig/CreateEmailConfig`,
    UPDATE_EMAILCONFIG: `${BaseGateway}/EmailConfig/UpdateItem`,
    DELETE_EMAILCONFIG: `${BaseGateway}/EmailConfig/DeleteItem`
};

export const LOGIN_HISTORY_API = {
    GET_PAGING_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetAllPaging`,
    STATISTIC_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetStatisticsLoginByAccount`,
    STATISTIC_COUNT_LOGIN_BY_DATE: `${BaseGatewayAuth}/LoginHistory/CountAllByDate`
};

export const LOG_API = {
    GET_PAGING_LOG: `${BaseGateway}/Log/GetAllByPaging`,
    DELETE_LOG: `${BaseGateway}/Log/DeleteByDate`,
    COUNT_LOG_BY_DATE: `${BaseGateway}/Log/CountLogsByDate`,
};

export const APIROLEMAPPING_API = {
    GET_PAGING: `${BaseGateway}/ApiRoleMapping/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ApiRoleMapping/GetItem`,
    ADD_ITEM: `${BaseGateway}/ApiRoleMapping/Create`,
    UPDATE_ITEM: `${BaseGateway}/ApiRoleMapping/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ApiRoleMapping/DeleteItem`,
    BULK_ASSIGN_ROLES: `${BaseGateway}/ApiRoleMapping/BulkAssignRoles`
};

// export const APIROLEMAPPING_API = {
//     GET_PAGING: `${BaseGatewayAuthApi}/ApiRoleMapping/GetAllByPaging`,
//     GET_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/GetItem`,
//     ADD_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/Create`,
//     UPDATE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/UpdateItem`,
//     DELETE_ITEM: `${BaseGatewayAuthApi}/ApiRoleMapping/DeleteItem`,
//     BULK_ASSIGN_ROLES: `${BaseGatewayAuthApi}/ApiRoleMapping/BulkAssignRoles`
// };

export const ROLE_API = {
    GET_ALL: `${BaseGatewayAuthApi}/Role/GetAll`,
    GET_PAGING: `${BaseGatewayAuthApi}/Role/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/Role/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/Role/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/Role/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/Role/DeleteItem`,
    UPDATE_TREE: `${BaseGatewayAuthApi}/Role/UpdateTree`
};

export const DONVI_API = {
    GET_PAGING: `${BaseGateway}/DonVi/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DonVi/GetItem`,
    ADD_ITEM: `${BaseGateway}/DonVi/Create`,
    UPDATE_ITEM: `${BaseGateway}/DonVi/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DonVi/DeleteItem`
};

export const CHUCVU_API = {
    GET_PAGING: `${BaseGateway}/ChucVu/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChucVu/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChucVu/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChucVu/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChucVu/DeleteItem`
};

export const CHUYENMON_API = {
    GET_PAGING: `${BaseGateway}/ChuyenMon/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ChuyenMon/GetItem`,
    ADD_ITEM: `${BaseGateway}/ChuyenMon/Create`,
    UPDATE_ITEM: `${BaseGateway}/ChuyenMon/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ChuyenMon/DeleteItem`
};

export const DONVIDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/DonViDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DonViDaoTao/GetItem`,
    ADD_ITEM: `${BaseGateway}/DonViDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/DonViDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DonViDaoTao/DeleteItem`
};

export const HINHTHUCDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/HinhThucDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/HinhThucDaoTao/GetItem`,
    ADD_ITEM: `${BaseGateway}/HinhThucDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/HinhThucDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/HinhThucDaoTao/DeleteItem`
};

export const NGANHDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/NganhDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/NganhDaoTao/GetItem`,
    ADD_ITEM: `${BaseGateway}/NganhDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/NganhDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/NganhDaoTao/DeleteItem`
};

export const TRINHDO_API = {
    GET_PAGING: `${BaseGateway}/TrinhDo/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/TrinhDo/GetItem`,
    ADD_ITEM: `${BaseGateway}/TrinhDo/Create`,
    UPDATE_ITEM: `${BaseGateway}/TrinhDo/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/TrinhDo/DeleteItem`
};

export const XEPLOAIDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/XepLoaiDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/XepLoaiDaoTao/GetItem`,
    ADD_ITEM: `${BaseGateway}/XepLoaiDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/XepLoaiDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/XepLoaiDaoTao/DeleteItem`
};

export const DOITUONG_API = {
    GET_PAGING: `${BaseGateway}/DoiTuong/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/DoiTuong/GetItem`,
    ADD_ITEM: `${BaseGateway}/DoiTuong/Create`,
    UPDATE_ITEM: `${BaseGateway}/DoiTuong/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/DoiTuong/DeleteItem`
};

export const ACCOUNTINFO_API = {
    GET_PAGING: `${BaseGateway}/AccountInfo/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AccountInfo/GetItem`,
    ADD_ITEM: `${BaseGateway}/AccountInfo/Create`,
    UPDATE_ITEM: `${BaseGateway}/AccountInfo/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AccountInfo/DeleteItem`,
    GET_BY_ACCOUNT_ID: `${BaseGateway}/AccountInfo/SelectAccountInfoByAccountId`
};

export const QUATRINHDAOTAO_API = {
    GET_PAGING: `${BaseGateway}/QuaTrinhDaoTao/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/QuaTrinhDaoTao/GetItem`,
    ADD_ITEM: `${BaseGateway}/QuaTrinhDaoTao/Create`,
    UPDATE_ITEM: `${BaseGateway}/QuaTrinhDaoTao/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/QuaTrinhDaoTao/DeleteItem`
};

export const MENU_API = {
    GET_PAGING: `${BaseGateway}/MenuItem/GetAllByPaging`,
    GET_MENU: `${BaseGateway}/MenuItem/GetMenu`,
    GET_ITEM: `${BaseGateway}/MenuItem/GetItem`,
    ADD_ITEM: `${BaseGateway}/MenuItem/Create`,
    UPDATE_ITEM: `${BaseGateway}/MenuItem/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MenuItem/DeleteItem`,
    UPDATE_TREE: `${BaseGateway}/MenuItem/UpdateTree`
};

export const KYSO_API = {
    KYSO: `${BaseGateway}/KySo/AuthorizeKySo`,
};


